import { GET_CALL_ACTIVITY_LOGS } from "../../constant/ActionType";

export default function CallGetActivityLogs(
    state = {
        allcallaclogs: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case GET_CALL_ACTIVITY_LOGS:
            return {
                ...state,
                allcallaclogs: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
